// import './core/core';
import integrateAttributes from './attributes/attributes';
import integrateComponents from './component/components';

const integration = () => {
  integrateAttributes();
  integrateComponents();
};

export default integration;
